import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  Status,
} from "../../../features/admin/heat_map/heat_map/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();
  const country = useSelector((state) => state.heat_map.heat_map);


  const [f_name, setName] = useState("");

  useEffect(() => {
    fetch();
  }, [f_name]);

  const fetch = async (page = country?.current_page) => {
    await dispatch(
      GetAll({
        f_name,
        page,
        per_page: country?.per_page,
      })
    );
  };

  // const deleteData = async (id) => {
  //   try {
  //     await dispatch(Delete(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  // const toggleStatus = async (id) => {
  //   try {
  //     await dispatch(Status(id));
  //     await fetch();
  //     return true;
  //   } catch (error) {
  //     console.error(error);
  //     return false;
  //   }
  // };

  return {
    country,
    f_name,
    setName,
    fetch,
    // deleteData,
    // toggleStatus,
  };
};
